import {html, clone, traverse, replace, append, css, define} from "@intrnl/velvet/internal";
import FeedbackForm from './components/FeedbackForm.velvet';
import FeedbackList from './components/FeedbackList.velvet';
let template0 = html("<main> <x></x> <x></x> </main>");
let style0 = css("main{display:flex;flex-direction:column;gap:16px;max-width:600px;margin:36px auto}");
function setup($$root, $$host) {
  let fragment0 = clone(template0);
  let child0 = new FeedbackForm();
  let marker0 = traverse(fragment0, [0, 1]);
  let child1 = new FeedbackList();
  let marker1 = traverse(fragment0, [0, 3]);
  replace(marker0, child0, true);
  replace(marker1, child1, true);
  append($$root, fragment0);
}
export default define("x-app", setup, {}, [style0]);
